import { createAction } from '@reduxjs/toolkit';
import { storeName } from '../config';
import { OkrObjectivesFilters } from '../interfaces';

export const changeFilter = createAction<{
  key: keyof OkrObjectivesFilters;
  value: string | number | number[] | null;
}>(`${storeName}/changeFilter`);
